import MainLayout from 'src/layouts';
import { Helmet } from 'react-helmet';
import TradeDataProductList from 'src/features/TradeData/ProductList';

const TradeDataProductListPage = () => {
  return (
    <MainLayout>
      <Helmet>
        <title>Trade Data Detail</title>
      </Helmet>
      <TradeDataProductList />
    </MainLayout>
  );
};

export default TradeDataProductListPage;
